import { motion } from 'framer-motion';
import Typewriter from '../Typewriter';
import { useBreakpoint } from '../../hooks/useBreakpoint';

const HeroSection = ({ heroComplete, setHeroComplete, showSubtext }) => {
  const { isMobile } = useBreakpoint();

  return (
    <section
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: isMobile ? '20px' : 16,
        position: 'relative',
      }}
    >
      <motion.div
        style={{ textAlign: 'center' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h1
          style={{
            fontSize: 'clamp(48px, 14vw, 160px)',
            fontWeight: 600,
            letterSpacing: '-0.04em',
            lineHeight: 1,
          }}
        >
          <Typewriter text="Go Blank." onComplete={() => setHeroComplete(true)} />
        </h1>
        <motion.p
          className="font-mono"
          style={{
            marginTop: 40,
            fontSize: isMobile ? 9 : 11,
            color: 'rgba(242,242,242,0.5)',
            textTransform: 'uppercase',
            letterSpacing: isMobile ? '0.2em' : '0.3em',
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: showSubtext ? 1 : 0 }}
        >
          Your safe corner of the internet.
        </motion.p>
      </motion.div>
      <motion.div
        style={{
          position: 'absolute',
          bottom: 32,
          left: '50%',
          transform: 'translateX(-50%)',
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: heroComplete ? 1 : 0 }}
        transition={{ delay: 1 }}
      >
        <motion.div
          style={{
            width: 1,
            height: 48,
            background: 'linear-gradient(to bottom, rgba(242,242,242,0.5), transparent)',
          }}
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        />
      </motion.div>
    </section>
  );
};

export default HeroSection;
